// Libraries
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params }   from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import * as _ from 'lodash';
import * as moment from 'moment';
// Services
import { BookingHolidayService } from '../../../services';
import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';
//Models
import { ClassChild, BookingItem } from '../../../models';

@Component({
    selector: 'review-schedule',
    template: require('./ExcursionsComponent.html'),
    styles: [ require('./ExcursionsComponent.sass') ]
})

export class ExcursionsComponent extends BookingComponent implements OnInit {
    private booking: any = []
    private excursions: any = []
    private filteredExcursions: any
    // Select excursions
    private selectedExcursion: any = []
    private agree: boolean = false
    private showAgreeWarning: boolean = false

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService
    ){
        super(router, services, sessionStorageService);
    }

    ngOnInit() {
        // Retrieve booking information from session
        this.booking = this.getBooking();
        // Get excursions
        this.getAllExcursions();
        // Init booking info
        this.initBooking();
    }

    // Initial booking from session
    initBooking() {
        if(this.booking.selectedExcursion && this.booking.selectedExcursion.length){
            this.selectedExcursion = this.booking.selectedExcursion;
            this.agree = true;
        }
        // For edit booking
        else{
            setTimeout(() => {
                _.forEach(this.booking.hol_weeks, (val, key) => {
                    // If we have excursion on this week
                    if(val.hol_booking_week.excursions.length){
                        // Find excursion with hol_week_id
                        let ex:any = _.find(this.excursions, {'hol_week_id': val.id})
                        // Set agreement
                        this.agree = true;
                        // Set to selectedExcursion
                        if(ex)
                            this.selectedExcursion[ex.id] = true;
                    }
                })               
            }, 100)
        }
    }

    getAllExcursions() {
        this.services.getExcursions().subscribe(
            result => {
                // Get excursions
                this.excursions = result;
                this.filteredExcursions = [];
                // Loop through selected weeks in booking info
                _.forEach(this.booking.periodWeeks, (wVal, wKey) => {
                    // Loop through excursions array
                    _.forEach(this.excursions, (exVal, exKey) => {
                        // If week id and class id is the same of excursion
                        if(wVal == exVal.hol_week_id && this.booking.hol_class_id == exVal.hol_class_id){
                            // push an excursion to filtered array
                            this.filteredExcursions.push({
                                week: _.find(this.booking.allWeek, {'id': wVal}),
                                excursion: exVal
                            });
                        }
                    })
                })
            },
            error => {

            }
        )
    }

    // Submit Excursion step
    submitExcursion() {
        // Display Terms and conditions agreement when unclick
        if(this.selectedExcursion.indexOf(true) !== -1){
            if(!this.agree){
                return this.showAgreeWarning = true;                
            }
        }
            
        // Renew weeks array
        this.booking.weeks = [];

        _.forEach(this.booking.periodWeeks, (wVal:any, wKey:any) => {
            let ex:any = _.find(this.excursions, {'hol_week_id': wVal, 'hol_class_id': this.booking.hol_class_id})
            if(ex && this.selectedExcursion[ex.id]){
                this.booking.weeks.push({
                    "hol_week_id": wVal,
                    "excursions": [
                        {
                            "name": ex.name,
                            "description": ex.description,
                            "place": ex.place
                        }
                    ]
                });
            }
            else{
                this.booking.weeks.push({
                    "hol_week_id": wVal,
                    "excursions": []
                });
            }
        });

        // Set selected excursions
        this.booking.selectedExcursion = this.selectedExcursion;
        // Store booking info to session
        this.setBooking(this.booking);
        // Navigate to next step

        // If no excursion was selected
        return this.router.navigate(['booking/bus']);      
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/4-excursions/ExcursionsComponent.ts